var _excluded = ["type", "autoFocus", "autoComplete", "disabled", "component", "error", "helperText", "success", "label", "name", "id", "value", "placeholder", "className", "onChange", "onFocus", "onBlur", "Icon"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useForkRef } from '@creditas-ui/utilities';
import { InputBoxedElement, InputLabel, Input, IconWrapper } from './InputBoxed.style';
import { useInputBoxed } from './useInputBoxed';
import { InputHelperText } from '../InputHelperText';
var InputBoxed = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    type = 'text',
    autoFocus = false,
    autoComplete = 'off',
    disabled = false,
    component,
    error,
    helperText,
    success,
    label,
    name,
    id,
    value,
    placeholder,
    className,
    onChange,
    onFocus,
    onBlur,
    Icon
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    active,
    focused,
    inputRef,
    handleOnBlur,
    handleOnFocus,
    handleOnClick
  } = useInputBoxed({
    value,
    disabled,
    placeholder,
    onBlur,
    onFocus,
    autoFocus
  });
  var handleRefs = useForkRef(ref, inputRef);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputBoxedElement, {
    onClick: handleOnClick,
    focused: focused,
    hasIcon: !!Icon
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: id || label,
    active: active,
    disabled: disabled,
    error: Boolean(error)
  }, label), /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: type,
    component: component,
    ref: handleRefs,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    disabled: disabled,
    name: name,
    id: id || label,
    value: value,
    placeholder: placeholder,
    className: className,
    onChange: onChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur
  })), Icon && /*#__PURE__*/React.createElement(IconWrapper, {
    disabled: disabled,
    role: "button"
  }, /*#__PURE__*/React.createElement(Icon, null))), helperText && !success && !error && /*#__PURE__*/React.createElement(InputHelperText, null, helperText), success && !error && /*#__PURE__*/React.createElement(InputHelperText, {
    success: true
  }, success), error && !disabled && /*#__PURE__*/React.createElement(InputHelperText, {
    error: true
  }, error));
});
export { InputBoxed };
//# sourceMappingURL=InputBoxed.js.map